import { render, staticRenderFns } from "./sceneSelectionHome.vue?vue&type=template&id=3c9b22c8&scoped=true"
import script from "./sceneSelectionHome.vue?vue&type=script&lang=js"
export * from "./sceneSelectionHome.vue?vue&type=script&lang=js"
import style0 from "./sceneSelectionHome.vue?vue&type=style&index=0&id=3c9b22c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b22c8",
  null
  
)

export default component.exports